export default __webpack_public_path__ + "static/media/flame.d0270232.jpg";